export const theme = {
  borderRadius: 12,
  gridSize: 20,

  colors: {
    primary: "#2f3542",
    primaryLight: "#57606f",

    secondary: "#ced6e0",
    secondaryLight: "#dfe4ea",

    grey: "#747d8c",
    greyLight: "#a4b0be",

    flashWhite: "#f1f2f6",
    white: "#ffffff",

    error: "#ff4757",
    errorLight: "#ff6b81",

    success: "#2ed573",
    successLight: "#7bed9f",

    warning: "#ffa502",
    warningLight: "#eccc68",

    blue: "#3742fa",
    blueLight: "#5352ed",

    link: "#1e90ff",
    linkLight: "#70a1ff",

    bitcoin: "#f7931a",
    lightning: "#ffd930"
  } as const
};
